module.exports = {

  maintenance_warnings_tab_title: "Advertencias de Mantenimientos",
  maintenance_warnings_tab_filter_by_last: "Más recientes",
  maintenance_warnings_tab_filter_by_date: "Entre",
  maintenance_warnings_tab_apply_filters: "Aplicar",

  maintenance_warnings_tab_date_range: "Por favor seleccione un rango de fechas valido",
  maintenance_warnings_tab_raw_message: "Mensaje sin Procesar",

  maintenance_warnings_tab_warning: "Advertencia",
  maintenance_warnings_tab_warning_time: "Fecha de Advertencia",
  maintenance_warnings_tab_value: "Valor",
  maintenance_warnings_tab_details: "Detalles",
  maintenance_warnings_tab_no_warnings: "No hay advertencias",
  maintenance_warnings_tab_sd_card_status: "El estado de la tarjeta SD es",
  maintenance_warnings_tab_last_status: "Último estado",

  maintenance_warnings_tab_resolve_all: "Resolver Todo",
  maintenance_warnings_tab_clear_all: "Limpiar Todo",
  maintenance_warnings_tab_search_by_warning: "Buscar por Advertencia",
  maintenance_warnings_tab_resolve_issue: "Resolver el Problema",
  maintenance_warnings_tab_clear: "Limpiar",
  maintenance_warnings_tab_first_occurrence: "Primera Incidencia",
  maintenance_warnings_tab_last_occurrence: "Última Incidencia",
  maintenance_warnings_tab_warnings: "Ocurrencias",
  maintenance_warnings_tab_issues: "Problemas",
  maintenance_warnings_tab_resolved: "Resueltos",

  maintenance_warnings_tab_default_message: "La descripción de esta advertencia llegará pronto!!!",
  maintenance_warnings_tab_back_to_issues: "Volver a Problemas",
  maintenance_warnings_tab_resolve: "Resolver",

  maintenance_warnings_tab_AuxCamDisconnected: "Cámara Aux Desconectada",
  maintenance_warnings_tab_BatteryVoltageLow: "Tensión de la Batería Baja",
  maintenance_warnings_tab_CameraDisconnectedFromServerOver7Days: "Cámara desconectada del servidor durante 7 días",
  maintenance_warnings_tab_CameraTilted: "Cámara Inclinada",
  maintenance_warnings_tab_dmsStatusChange: "Cambio de Estado de DMS",
  maintenance_warnings_tab_DrivingOver18Hours: "Conducir más de 18 Horas",
  maintenance_warnings_tab_FailedToEnterStandby: "Error al Entrar en Modo de Espera",
  maintenance_warnings_tab_FormatSDCard: "Formatear Tarjeta SD",
  maintenance_warnings_tab_GPSGapTooLarge: "Espacio GPS Demasiado Grande",
  maintenance_warnings_tab_LowVBUSVoltage: "Tensión VBUS baja",
  maintenance_warnings_tab_MCUDisconnected: "MCU Desconectado",
  maintenance_warnings_tab_ReplaceSDCard: "Reemplazar Tarjeta SD",
  maintenance_warnings_tab_SDCardStatus: "Estado de la Tarjeta SD",
  maintenance_warnings_tab_SIMCardInfoChanged: "Información de la Tarjeta SIM Modificada",
  maintenance_warnings_tab_UnfavorableAngleOfRoadView: "Ángulo Desfavorable de Visión de la Carretera",
  maintenance_warnings_tab_VinNumChanged: "Vin Num Cambiado",
  maintenance_warnings_tab_UnsupportedVideoConfigCombinations: "Combinaciones de Configuración de Vídeo no Compatibles: Compruebe las Restricciones en el Documento",
  maintenance_warnings_tab_HDOPQuality: "Calidad HDOP",
  maintenance_warnings_tab_ExcessiveEvents: "Eventos Excesivos",
  maintenance_warnings_tab_LowBattery: "Batería Baja",
  maintenance_warnings_tab_IgnitionOnEventsAbnormal: "Encendido Anormal",
  maintenance_warnings_tab_PowerDisconnect: "Desconexión de la Alimentación",
  maintenance_warnings_tab_LowSatellites: "Satélites Bajos",
  maintenance_warnings_tab_DailyOdometerExceeded: "Cuentakilómetros Diario Superado",
  maintenance_warnings_tab_WirelessSignal: "Señal Inalámbrica",
  maintenance_warnings_tab_MaintenanceLimitExceeded: "Límite de Mantenimiento Superado",
  maintenance_warnings_tab_LateEvents: "Eventos Tardíos",
  maintenance_warnings_tab_CommLost: "Comunicación Perdida",
  maintenance_warnings_tab_DailyEngineHoursExceeded: "Horas Diarias de Motor Superadas",

  maintenance_warnings_tab_resolve_all_warnings: "Resolver Todas las Advertencias",
  maintenance_warnings_tab_resolve_warning: "Resolver Advertencia",
  maintenance_warnings_tab_success_message_all: "Las advertencias se han resuelto",
  maintenance_warnings_tab_success_message: "La advertencia se ha resuelto",
  maintenance_warnings_tab_error_message_all: "Las advertencias no se han podido resolver debido a un error",
  maintenance_warnings_tab_error_message: "No se ha podido resolver la advertencia debido a un error",
  maintenance_warnings_tab_description_all: "¿Está seguro de que desea resolver todas las advertencias? Esta acción no se puede deshacer.",
  maintenance_warnings_tab_description: "¿Está seguro de que desea resolver la advertencia? Esta acción no se puede deshacer.",

  maintenance_warnings_tab_delete_warnings: "Eliminar Advertencias",
  maintenance_warnings_tab_delete_warning: "Eliminar Advertencia",
  maintenance_warnings_tab_success_message_delete_all: "Se han eliminado las advertencias",
  maintenance_warnings_tab_success_message_delete: "Se ha eliminado la advertencia",
  maintenance_warnings_tab_error_message_delete_all: "No se han podido eliminar las advertencias debido a un error",
  maintenance_warnings_tab_error_message_delete: "No se ha podido eliminar la advertencia debido a un error",
  maintenance_warnings_tab_description_delete_all: "¿Está seguro de que desea eliminar todas las advertencias? Esta acción no se puede deshacer.",
  maintenance_warnings_tab_description_delete: "¿Estás seguro de que quieres eliminar la advertencia? Esta acción no se puede deshacer.",
  maintenance_warnings_tab_resolved_on: "Resuelto En",
  maintenance_warnings_tab_resolved_by: "Resuelto Por",
}
